import { render, staticRenderFns } from "./TipoAsistencias.vue?vue&type=template&id=526a8851&"
import script from "./TipoAsistencias.vue?vue&type=script&lang=js&"
export * from "./TipoAsistencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports